"use strict";

var _interopRequireDefault = require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toggleDateIncludedInList = exports.parseScheduleAllSessionsErrors = exports.normalizeSlotStartKey = exports.normalizeSchedulingResponse = exports.mergeDatesWithAvailability = exports.mapSlotAvailabilityFields = exports.isWeeklyWarning = exports.isWeeklyLimitWarningSlot = exports.isSessionRestrictionSlot = exports.isSelectableDateItem = exports.isScheduleAllSessionWeeklyWarningEntry = exports.isScheduleAllSessionHardBlockCode = exports.isSameDayConflictSlot = exports.isSameDayConflict = exports.isMaxSessionsPerWeekExceededSlot = exports.isMaxSessionsPerWeekExceeded = exports.isIncludedDateItem = exports.isHardSchedulingBlock = exports.isFirstSessionScheduling = exports.isFirstSessionMissing = exports.isBlockingUnavailableSlot = exports.hasBlockingUnavailableSlots = exports.getWeeklyWarningMessage = exports.getUnavailableSlotsTooltip = exports.getSlotRestrictionMessage = exports.getSchedulableDatesFromList = exports.getOrderedSessionIndicesFromPayload = exports.getConstraintMessage = exports.executeSchedulingRequest = exports.evaluateSlotAvailabilityItem = exports.WEEKLY_LIMIT_WARNING_CODE = exports.SlotAvailabilityCheckResult = exports.SchedulingResultType = exports.SLOT_NO_LONGER_AVAILABLE_CODE = exports.SAME_DAY_SHORT_MESSAGE = exports.SAME_DAY_RESTRICTION_MESSAGE = exports.SAME_DAY_DUPLICATE_IN_REQUEST_CODE = exports.SAME_DAY_CONFLICT_CODE = exports.MAX_SESSIONS_PER_WEEK_EXCEEDED_CODE = exports.FIRST_SESSION_REQUIRED_MESSAGE = exports.DEFAULT_WEEKLY_WARNING_MESSAGE = exports.DEFAULT_SAME_DAY_DUPLICATE_IN_REQUEST_MESSAGE = exports.DEFAULT_MAX_SESSIONS_PER_WEEK_MESSAGE = void 0;

var _index = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/regenerator/index.js"));

var _asyncToGenerator2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js"));

var _defineProperty2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/defineProperty.js"));

var _objectSpread2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));

var _typeof2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/typeof.js"));

var SAME_DAY_CONFLICT_CODE = 'SAME_DAY_CONFLICT';
exports.SAME_DAY_CONFLICT_CODE = SAME_DAY_CONFLICT_CODE;
var WEEKLY_LIMIT_WARNING_CODE = 'WEEKLY_LIMIT_WARNING';
exports.WEEKLY_LIMIT_WARNING_CODE = WEEKLY_LIMIT_WARNING_CODE;
var MAX_SESSIONS_PER_WEEK_EXCEEDED_CODE = 'MAX_SESSIONS_PER_WEEK_EXCEEDED';
exports.MAX_SESSIONS_PER_WEEK_EXCEEDED_CODE = MAX_SESSIONS_PER_WEEK_EXCEEDED_CODE;
var SAME_DAY_DUPLICATE_IN_REQUEST_CODE = 'SAME_DAY_DUPLICATE_IN_REQUEST';
exports.SAME_DAY_DUPLICATE_IN_REQUEST_CODE = SAME_DAY_DUPLICATE_IN_REQUEST_CODE;
var SLOT_NO_LONGER_AVAILABLE_CODE = 'SLOT_NO_LONGER_AVAILABLE';
exports.SLOT_NO_LONGER_AVAILABLE_CODE = SLOT_NO_LONGER_AVAILABLE_CODE;
var SAME_DAY_RESTRICTION_MESSAGE = 'You already have a coaching session scheduled on this day. Only one coaching session per day is allowed.';
exports.SAME_DAY_RESTRICTION_MESSAGE = SAME_DAY_RESTRICTION_MESSAGE;
var SAME_DAY_SHORT_MESSAGE = 'You already have a coaching session scheduled for this day.';
exports.SAME_DAY_SHORT_MESSAGE = SAME_DAY_SHORT_MESSAGE;
var DEFAULT_WEEKLY_WARNING_MESSAGE = 'You already have a coaching session scheduled for this week. Are you sure you wish to book another session? (Max 2 per week)';
exports.DEFAULT_WEEKLY_WARNING_MESSAGE = DEFAULT_WEEKLY_WARNING_MESSAGE;
var DEFAULT_MAX_SESSIONS_PER_WEEK_MESSAGE = 'You cannot book more than 2 sessions in a single week. Please choose dates in different weeks.';
exports.DEFAULT_MAX_SESSIONS_PER_WEEK_MESSAGE = DEFAULT_MAX_SESSIONS_PER_WEEK_MESSAGE;
var DEFAULT_SAME_DAY_DUPLICATE_IN_REQUEST_MESSAGE = 'You cannot book multiple sessions on the same day in one request.';
exports.DEFAULT_SAME_DAY_DUPLICATE_IN_REQUEST_MESSAGE = DEFAULT_SAME_DAY_DUPLICATE_IN_REQUEST_MESSAGE;
var SchedulingResultType = {
  SUCCESS: 'success',
  SAME_DAY_CONFLICT: 'same_day_conflict',
  WEEKLY_WARNING: 'weekly_warning',
  SESSION_ERRORS: 'session_errors',
  ERROR: 'error'
};
exports.SchedulingResultType = SchedulingResultType;
var SCHEDULE_ALL_HARD_BLOCK_CODES = [SAME_DAY_CONFLICT_CODE, // MAX_SESSIONS_PER_WEEK_EXCEEDED_CODE, // old: hard-blocked 3rd session per week
SAME_DAY_DUPLICATE_IN_REQUEST_CODE, // Slot was taken or removed after the calendar loaded: surface it per session
// so the user can re-pick instead of getting a generic failure toast.
SLOT_NO_LONGER_AVAILABLE_CODE];
var SlotAvailabilityCheckResult = {
  ALLOWED: 'allowed',
  HARD_BLOCK: 'hard_block',
  WEEKLY_WARNING: 'weekly_warning',
  UNAVAILABLE: 'unavailable'
};
exports.SlotAvailabilityCheckResult = SlotAvailabilityCheckResult;
var COACH_UNAVAILABLE_MESSAGE = 'Coach is not available at this time. Please choose another slot.';

var normalizeSchedulingResponse = function normalizeSchedulingResponse(response) {
  var _response$response;

  if (!response) {
    return null;
  } // Axios error envelope


  if ((_response$response = response.response) !== null && _response$response !== void 0 && _response$response.data) {
    return response.response.data;
  } // Plain body rejected by RestClient (errorHandle rejects error.response.data)


  if ((0, _typeof2["default"])(response) === 'object' && (Object.prototype.hasOwnProperty.call(response, 'requiresConfirmation') || Object.prototype.hasOwnProperty.call(response, 'success') || Object.prototype.hasOwnProperty.call(response, 'code') || Object.prototype.hasOwnProperty.call(response, 'sessionConstraint'))) {
    return response;
  } // Axios success envelope { data, status, headers, ... }


  if (response.data && (0, _typeof2["default"])(response.data) === 'object') {
    return response.data;
  }

  return response;
};

exports.normalizeSchedulingResponse = normalizeSchedulingResponse;

var isSameDayConflict = function isSameDayConflict(response) {
  var _data$sessionConstrai;

  var data = normalizeSchedulingResponse(response);

  if (!data) {
    return false;
  }

  return data.code === SAME_DAY_CONFLICT_CODE || ((_data$sessionConstrai = data.sessionConstraint) === null || _data$sessionConstrai === void 0 ? void 0 : _data$sessionConstrai.code) === SAME_DAY_CONFLICT_CODE;
};

exports.isSameDayConflict = isSameDayConflict;

var isMaxSessionsPerWeekExceeded = function isMaxSessionsPerWeekExceeded(response) {
  var _data$sessionConstrai2;

  var data = normalizeSchedulingResponse(response);

  if (!data) {
    return false;
  }

  return data.code === MAX_SESSIONS_PER_WEEK_EXCEEDED_CODE || ((_data$sessionConstrai2 = data.sessionConstraint) === null || _data$sessionConstrai2 === void 0 ? void 0 : _data$sessionConstrai2.code) === MAX_SESSIONS_PER_WEEK_EXCEEDED_CODE;
};

exports.isMaxSessionsPerWeekExceeded = isMaxSessionsPerWeekExceeded;

var isHardSchedulingBlock = function isHardSchedulingBlock(response) {
  // old: return isSameDayConflict(response) || isMaxSessionsPerWeekExceeded(response)
  return isSameDayConflict(response);
};

exports.isHardSchedulingBlock = isHardSchedulingBlock;

var isWeeklyWarning = function isWeeklyWarning(response) {
  var _data$sessionConstrai3;

  var data = normalizeSchedulingResponse(response);

  if (!data || isHardSchedulingBlock(data)) {
    return false;
  } // old isWeeklyWarning did not include isMaxSessionsPerWeekExceeded(data)


  return isMaxSessionsPerWeekExceeded(data) || // new: 3rd session/week is confirmable, not hard-blocked
  data.requiresConfirmation === true || data.status === 'warning' || data.code === WEEKLY_LIMIT_WARNING_CODE || ((_data$sessionConstrai3 = data.sessionConstraint) === null || _data$sessionConstrai3 === void 0 ? void 0 : _data$sessionConstrai3.code) === WEEKLY_LIMIT_WARNING_CODE;
};

exports.isWeeklyWarning = isWeeklyWarning;

var getConstraintMessage = function getConstraintMessage(response) {
  var _data$sessionConstrai5;

  var data = normalizeSchedulingResponse(response);

  if (!data) {
    return SAME_DAY_RESTRICTION_MESSAGE;
  }

  if (isMaxSessionsPerWeekExceeded(data)) {
    var _data$sessionConstrai4;

    return data.message || ((_data$sessionConstrai4 = data.sessionConstraint) === null || _data$sessionConstrai4 === void 0 ? void 0 : _data$sessionConstrai4.message) || DEFAULT_MAX_SESSIONS_PER_WEEK_MESSAGE;
  }

  return data.message || ((_data$sessionConstrai5 = data.sessionConstraint) === null || _data$sessionConstrai5 === void 0 ? void 0 : _data$sessionConstrai5.message) || SAME_DAY_RESTRICTION_MESSAGE;
};

exports.getConstraintMessage = getConstraintMessage;

var getWeeklyWarningMessage = function getWeeklyWarningMessage(response) {
  var _data$sessionConstrai6;

  var data = normalizeSchedulingResponse(response);
  return (data === null || data === void 0 ? void 0 : data.message) || (data === null || data === void 0 ? void 0 : (_data$sessionConstrai6 = data.sessionConstraint) === null || _data$sessionConstrai6 === void 0 ? void 0 : _data$sessionConstrai6.message) || DEFAULT_WEEKLY_WARNING_MESSAGE;
};

exports.getWeeklyWarningMessage = getWeeklyWarningMessage;

var isSameDayConflictSlot = function isSameDayConflictSlot(dateItem) {
  var _dateItem$sessionCons;

  if (!dateItem || dateItem.isSlotAvailable !== false) {
    return false;
  }

  return dateItem.isSameDayConflict === true || ((_dateItem$sessionCons = dateItem.sessionConstraint) === null || _dateItem$sessionCons === void 0 ? void 0 : _dateItem$sessionCons.code) === SAME_DAY_CONFLICT_CODE;
};

exports.isSameDayConflictSlot = isSameDayConflictSlot;

var isWeeklyLimitWarningSlot = function isWeeklyLimitWarningSlot(dateItem) {
  var _dateItem$sessionCons2;

  if (!dateItem || dateItem.isSlotAvailable !== false) {
    return false;
  }

  return dateItem.isWeeklyLimitWarning === true || ((_dateItem$sessionCons2 = dateItem.sessionConstraint) === null || _dateItem$sessionCons2 === void 0 ? void 0 : _dateItem$sessionCons2.code) === WEEKLY_LIMIT_WARNING_CODE;
};

exports.isWeeklyLimitWarningSlot = isWeeklyLimitWarningSlot;

var isMaxSessionsPerWeekExceededSlot = function isMaxSessionsPerWeekExceededSlot(dateItem) {
  var _dateItem$sessionCons3;

  if (!dateItem || dateItem.isSlotAvailable !== false) {
    return false;
  }

  return dateItem.isMaxSessionsPerWeekExceeded === true || ((_dateItem$sessionCons3 = dateItem.sessionConstraint) === null || _dateItem$sessionCons3 === void 0 ? void 0 : _dateItem$sessionCons3.code) === MAX_SESSIONS_PER_WEEK_EXCEEDED_CODE;
};

exports.isMaxSessionsPerWeekExceededSlot = isMaxSessionsPerWeekExceededSlot;

var isSessionRestrictionSlot = function isSessionRestrictionSlot(dateItem) {
  return isSameDayConflictSlot(dateItem) || isWeeklyLimitWarningSlot(dateItem) || isMaxSessionsPerWeekExceededSlot(dateItem);
}; // Hard block: same-day or coach unavailable (weekly / max-per-week warnings are confirmable).
// old: Hard block: same-day, max sessions/week, or coach unavailable (not weekly warning).


exports.isSessionRestrictionSlot = isSessionRestrictionSlot;

var isBlockingUnavailableSlot = function isBlockingUnavailableSlot(dateItem) {
  if (!dateItem || dateItem.isSlotAvailable !== false) {
    return false;
  }

  if (isWeeklyLimitWarningSlot(dateItem) || isMaxSessionsPerWeekExceededSlot(dateItem)) {
    return false;
  } // old: only isWeeklyLimitWarningSlot(dateItem) was non-blocking; max-per-week slots blocked scheduling


  return true;
};

exports.isBlockingUnavailableSlot = isBlockingUnavailableSlot;

var hasBlockingUnavailableSlots = function hasBlockingUnavailableSlots() {
  var selectedDates = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return selectedDates.some(function (dateItem) {
    return isBlockingUnavailableSlot(dateItem);
  });
}; // A date can be ticked for booking unless the coach is hard-blocked on it.


exports.hasBlockingUnavailableSlots = hasBlockingUnavailableSlots;

var isSelectableDateItem = function isSelectableDateItem(dateItem) {
  return !!dateItem && !isBlockingUnavailableSlot(dateItem);
}; // Default is included; the user can untick a selectable date (isIncluded === false).


exports.isSelectableDateItem = isSelectableDateItem;

var isIncludedDateItem = function isIncludedDateItem(dateItem) {
  return isSelectableDateItem(dateItem) && dateItem.isIncluded !== false;
}; // Bookable dates are the selected (ticked) ones. No sessionIndex is added here;
// the backend numbers sessions by their order in timeSlots, as it did before.


exports.isIncludedDateItem = isIncludedDateItem;

var getSchedulableDatesFromList = function getSchedulableDatesFromList() {
  var selectedDates = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return selectedDates.filter(function (dateItem) {
    return isIncludedDateItem(dateItem);
  });
};

exports.getSchedulableDatesFromList = getSchedulableDatesFromList;

var toggleDateIncludedInList = function toggleDateIncludedInList() {
  var selectedDates = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var index = arguments.length > 1 ? arguments[1] : undefined;
  return selectedDates.map(function (dateItem, i) {
    if (i !== index || !isSelectableDateItem(dateItem)) {
      return dateItem;
    }

    return (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, dateItem), {}, {
      isIncluded: dateItem.isIncluded === false
    });
  });
};

exports.toggleDateIncludedInList = toggleDateIncludedInList;
var FIRST_SESSION_REQUIRED_MESSAGE = 'Please schedule the first session'; // The first-session rule applies only while no session of the program is booked yet.
// Once Session 1 is booked, later submissions are not checked for it.

exports.FIRST_SESSION_REQUIRED_MESSAGE = FIRST_SESSION_REQUIRED_MESSAGE;

var isFirstSessionScheduling = function isFirstSessionScheduling(coachDetails) {
  var totalSessions = Number(coachDetails === null || coachDetails === void 0 ? void 0 : coachDetails.totalSessions) || 0;
  var remainingSessions = Number(coachDetails === null || coachDetails === void 0 ? void 0 : coachDetails.remainingSessions);
  return totalSessions > 0 && remainingSessions === totalSessions;
}; // Session 1 is the first date in the list. It must be ticked and error-free
// (not blocked by same-day, coach unavailable, etc.) for the submission to go through.


exports.isFirstSessionScheduling = isFirstSessionScheduling;

var isFirstSessionMissing = function isFirstSessionMissing() {
  var selectedDates = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return !isIncludedDateItem(selectedDates[0]);
};

exports.isFirstSessionMissing = isFirstSessionMissing;

var getSlotRestrictionMessage = function getSlotRestrictionMessage(dateItem) {
  if (isSameDayConflictSlot(dateItem)) {
    var _dateItem$sessionCons4;

    return dateItem.slotRestrictionMessage || ((_dateItem$sessionCons4 = dateItem.sessionConstraint) === null || _dateItem$sessionCons4 === void 0 ? void 0 : _dateItem$sessionCons4.message) || SAME_DAY_RESTRICTION_MESSAGE;
  }

  if (isMaxSessionsPerWeekExceededSlot(dateItem)) {
    var _dateItem$sessionCons5;

    return dateItem.slotRestrictionMessage || ((_dateItem$sessionCons5 = dateItem.sessionConstraint) === null || _dateItem$sessionCons5 === void 0 ? void 0 : _dateItem$sessionCons5.message) || DEFAULT_MAX_SESSIONS_PER_WEEK_MESSAGE;
  }

  if (isWeeklyLimitWarningSlot(dateItem)) {
    var _dateItem$sessionCons6;

    return dateItem.slotRestrictionMessage || ((_dateItem$sessionCons6 = dateItem.sessionConstraint) === null || _dateItem$sessionCons6 === void 0 ? void 0 : _dateItem$sessionCons6.message) || DEFAULT_WEEKLY_WARNING_MESSAGE;
  }

  return null;
};

exports.getSlotRestrictionMessage = getSlotRestrictionMessage;

var evaluateSlotAvailabilityItem = function evaluateSlotAvailabilityItem(apiItem) {
  if (!apiItem) {
    return {
      type: SlotAvailabilityCheckResult.ALLOWED
    };
  }

  var mapped = mapSlotAvailabilityFields(apiItem);

  if (mapped.isSlotAvailable !== false) {
    return {
      type: SlotAvailabilityCheckResult.ALLOWED
    };
  }

  if (isWeeklyLimitWarningSlot(mapped) || isMaxSessionsPerWeekExceededSlot(mapped)) {
    return {
      type: SlotAvailabilityCheckResult.WEEKLY_WARNING,
      message: getSlotRestrictionMessage(mapped) || DEFAULT_WEEKLY_WARNING_MESSAGE
    };
  } // old: isMaxSessionsPerWeekExceededSlot(mapped) returned HARD_BLOCK (with same-day), not WEEKLY_WARNING


  if (isSameDayConflictSlot(mapped)) {
    return {
      type: SlotAvailabilityCheckResult.HARD_BLOCK,
      message: getSlotRestrictionMessage(mapped)
    };
  }

  return {
    type: SlotAvailabilityCheckResult.UNAVAILABLE,
    message: COACH_UNAVAILABLE_MESSAGE
  };
};

exports.evaluateSlotAvailabilityItem = evaluateSlotAvailabilityItem;

var mapSlotAvailabilityFields = function mapSlotAvailabilityFields(item) {
  var _ref;

  var sessionConstraint = item.sessionConstraint || null;
  var isUnavailable = item.isSlotAvailable === false;
  var isSameDay = (sessionConstraint === null || sessionConstraint === void 0 ? void 0 : sessionConstraint.code) === SAME_DAY_CONFLICT_CODE && isUnavailable;
  var isWeeklyLimit = (sessionConstraint === null || sessionConstraint === void 0 ? void 0 : sessionConstraint.code) === WEEKLY_LIMIT_WARNING_CODE && isUnavailable;
  var isMaxSessionsPerWeek = (sessionConstraint === null || sessionConstraint === void 0 ? void 0 : sessionConstraint.code) === MAX_SESSIONS_PER_WEEK_EXCEEDED_CODE && isUnavailable;
  var slotRestrictionMessage = null;

  if (isSameDay) {
    slotRestrictionMessage = (sessionConstraint === null || sessionConstraint === void 0 ? void 0 : sessionConstraint.message) || SAME_DAY_RESTRICTION_MESSAGE;
  } else if (isMaxSessionsPerWeek) {
    slotRestrictionMessage = (sessionConstraint === null || sessionConstraint === void 0 ? void 0 : sessionConstraint.message) || DEFAULT_MAX_SESSIONS_PER_WEEK_MESSAGE;
  } else if (isWeeklyLimit) {
    slotRestrictionMessage = (sessionConstraint === null || sessionConstraint === void 0 ? void 0 : sessionConstraint.message) || DEFAULT_WEEKLY_WARNING_MESSAGE;
  }

  return _ref = {
    isSlotAvailable: item.isSlotAvailable !== false,
    eventStart: item.eventStart,
    eventEnd: item.eventEnd,
    duration: item.duration,
    isGrowthSlot: item.isGrowthSlot
  }, (0, _defineProperty2["default"])(_ref, "duration", item.duration), (0, _defineProperty2["default"])(_ref, "sessionConstraint", sessionConstraint), (0, _defineProperty2["default"])(_ref, "isSameDayConflict", isSameDay), (0, _defineProperty2["default"])(_ref, "isWeeklyLimitWarning", isWeeklyLimit), (0, _defineProperty2["default"])(_ref, "isMaxSessionsPerWeekExceeded", isMaxSessionsPerWeek), (0, _defineProperty2["default"])(_ref, "requiresConfirmation", (sessionConstraint === null || sessionConstraint === void 0 ? void 0 : sessionConstraint.requiresConfirmation) === true), (0, _defineProperty2["default"])(_ref, "slotRestrictionMessage", slotRestrictionMessage), _ref;
};

exports.mapSlotAvailabilityFields = mapSlotAvailabilityFields;

var normalizeSlotStartKey = function normalizeSlotStartKey(slotStart) {
  if (!slotStart) {
    return '';
  }

  try {
    var parsed = new Date(slotStart);

    if (!Number.isNaN(parsed.getTime())) {
      return parsed.toISOString();
    }
  } catch (error) {// fall through to string key
  }

  return String(slotStart);
};

exports.normalizeSlotStartKey = normalizeSlotStartKey;

var mergeDatesWithAvailability = function mergeDatesWithAvailability(dates, apiData) {
  if (!Array.isArray(dates) || !Array.isArray(apiData)) {
    return dates;
  }

  var availabilityBySlot = {};
  apiData.forEach(function (item) {
    var key = normalizeSlotStartKey(item.slotStart);

    if (key) {
      availabilityBySlot[key] = mapSlotAvailabilityFields(item);
    }
  });
  return dates.map(function (dateItem, index) {
    var apiItem = apiData[index];
    var availability = apiItem && mapSlotAvailabilityFields(apiItem) || availabilityBySlot[normalizeSlotStartKey(dateItem.slotStart)] || {};
    return (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, dateItem), availability);
  });
};

exports.mergeDatesWithAvailability = mergeDatesWithAvailability;

var getUnavailableSlotsTooltip = function getUnavailableSlotsTooltip() {
  var selectedDates = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var blocking = selectedDates.filter(function (dateItem) {
    return isBlockingUnavailableSlot(dateItem);
  });

  if (blocking.length === 0) {
    return null;
  }

  var restrictionSlot = blocking.find(function (dateItem) {
    return getSlotRestrictionMessage(dateItem);
  });

  if (restrictionSlot) {
    return getSlotRestrictionMessage(restrictionSlot);
  }

  return 'Coach is not available, please change it first';
};

exports.getUnavailableSlotsTooltip = getUnavailableSlotsTooltip;

var getOrderedSessionIndicesFromPayload = function getOrderedSessionIndicesFromPayload() {
  var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (!Array.isArray(payload === null || payload === void 0 ? void 0 : payload.timeSlots)) {
    return [];
  }

  return payload.timeSlots.map(function (slot, index) {
    if ((slot === null || slot === void 0 ? void 0 : slot.sessionIndex) != null) {
      return Number(slot.sessionIndex);
    }

    return index + 1;
  });
};

exports.getOrderedSessionIndicesFromPayload = getOrderedSessionIndicesFromPayload;

var isScheduleAllSessionHardBlockCode = function isScheduleAllSessionHardBlockCode(code) {
  return SCHEDULE_ALL_HARD_BLOCK_CODES.includes(code);
};

exports.isScheduleAllSessionHardBlockCode = isScheduleAllSessionHardBlockCode;

var isScheduleAllSessionWeeklyWarningEntry = function isScheduleAllSessionWeeklyWarningEntry(entry) {
  if ((entry === null || entry === void 0 ? void 0 : entry.code) === MAX_SESSIONS_PER_WEEK_EXCEEDED_CODE) {
    return true; // new: 3rd session/week uses weekly confirmation flow
  }

  return (entry === null || entry === void 0 ? void 0 : entry.code) === WEEKLY_LIMIT_WARNING_CODE && (entry === null || entry === void 0 ? void 0 : entry.requiresConfirmation) === true; // old: only WEEKLY_LIMIT_WARNING_CODE with requiresConfirmation; MAX_SESSIONS was hard-blocked via SCHEDULE_ALL_HARD_BLOCK_CODES
};

exports.isScheduleAllSessionWeeklyWarningEntry = isScheduleAllSessionWeeklyWarningEntry;

var parseScheduleAllSessionsErrors = function parseScheduleAllSessionsErrors(response) {
  var _invalidSessions$find, _invalidSessions$;

  var orderedSessionIndices = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var data = normalizeSchedulingResponse(response) || response;

  if (!data || data.success !== false || !Array.isArray(data.error)) {
    return null;
  }

  var perSession = data.error.map(function (item, index) {
    var _orderedSessionIndice;

    var sessionIndex = (_orderedSessionIndice = orderedSessionIndices[index]) !== null && _orderedSessionIndice !== void 0 ? _orderedSessionIndice : index + 1;
    var err = item === null || item === void 0 ? void 0 : item.error;
    var isValid = (item === null || item === void 0 ? void 0 : item.isValid) === true || !err;
    return {
      sessionIndex: sessionIndex,
      isValid: isValid,
      code: (err === null || err === void 0 ? void 0 : err.code) || null,
      message: (err === null || err === void 0 ? void 0 : err.message) || null,
      requiresConfirmation: (err === null || err === void 0 ? void 0 : err.requiresConfirmation) === true
    };
  });
  var invalidSessions = perSession.filter(function (session) {
    return !session.isValid;
  });

  if (invalidSessions.length === 0) {
    return null;
  }

  var hasHardBlock = invalidSessions.some(function (session) {
    return isScheduleAllSessionHardBlockCode(session.code) || session.code === WEEKLY_LIMIT_WARNING_CODE && !session.requiresConfirmation;
  });
  var hasWeeklyWarning = !hasHardBlock && invalidSessions.every(function (session) {
    return isScheduleAllSessionWeeklyWarningEntry(session);
  });
  var weeklyMessage = ((_invalidSessions$find = invalidSessions.find(function (session) {
    return session.code === WEEKLY_LIMIT_WARNING_CODE || session.code === MAX_SESSIONS_PER_WEEK_EXCEEDED_CODE;
  } // new: include 3rd-session warning message
  )) === null || _invalidSessions$find === void 0 ? void 0 : _invalidSessions$find.message) || DEFAULT_WEEKLY_WARNING_MESSAGE; // old weeklyMessage: invalidSessions.find((session) => session.code === WEEKLY_LIMIT_WARNING_CODE)

  var summaryMessage = ((_invalidSessions$ = invalidSessions[0]) === null || _invalidSessions$ === void 0 ? void 0 : _invalidSessions$.message) || 'Unable to schedule sessions. Please review the highlighted sessions.';
  return {
    perSession: perSession,
    invalidSessions: invalidSessions,
    hasWeeklyWarning: hasWeeklyWarning,
    hasHardBlock: hasHardBlock,
    weeklyMessage: weeklyMessage,
    summaryMessage: summaryMessage
  };
};

exports.parseScheduleAllSessionsErrors = parseScheduleAllSessionsErrors;

var executeSchedulingRequest = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_index["default"].mark(function _callee(apiFn) {
    var _data, _data2, _data3;

    var payload,
        data,
        orderedSessionIndices,
        _response$data,
        response,
        _scheduleAllErrors,
        scheduleAllErrors,
        _args = arguments;

    return _index["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            payload = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
            orderedSessionIndices = getOrderedSessionIndicesFromPayload(payload);
            _context.prev = 2;
            _context.next = 5;
            return apiFn(payload);

          case 5:
            response = _context.sent;
            data = (_response$data = response === null || response === void 0 ? void 0 : response.data) !== null && _response$data !== void 0 ? _response$data : response;
            _context.next = 19;
            break;

          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](2);
            data = normalizeSchedulingResponse(_context.t0);
            _scheduleAllErrors = parseScheduleAllSessionsErrors(data, orderedSessionIndices);

            if (!_scheduleAllErrors) {
              _context.next = 17;
              break;
            }

            data = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, data), {}, {
              _scheduleAllErrors: _scheduleAllErrors
            });
            _context.next = 19;
            break;

          case 17:
            if (!(!isHardSchedulingBlock(data) && !isWeeklyWarning(data))) {
              _context.next = 19;
              break;
            }

            throw _context.t0;

          case 19:
            scheduleAllErrors = ((_data = data) === null || _data === void 0 ? void 0 : _data._scheduleAllErrors) || parseScheduleAllSessionsErrors(data, orderedSessionIndices);

            if (!(scheduleAllErrors !== null && scheduleAllErrors !== void 0 && scheduleAllErrors.hasHardBlock)) {
              _context.next = 22;
              break;
            }

            return _context.abrupt("return", {
              type: SchedulingResultType.SESSION_ERRORS,
              perSessionErrors: scheduleAllErrors.invalidSessions,
              message: scheduleAllErrors.summaryMessage
            });

          case 22:
            if (!(scheduleAllErrors !== null && scheduleAllErrors !== void 0 && scheduleAllErrors.hasWeeklyWarning)) {
              _context.next = 24;
              break;
            }

            return _context.abrupt("return", {
              type: SchedulingResultType.WEEKLY_WARNING,
              message: scheduleAllErrors.weeklyMessage,
              apiFn: apiFn,
              payload: payload,
              perSessionErrors: scheduleAllErrors.invalidSessions
            });

          case 24:
            if (!isHardSchedulingBlock(data)) {
              _context.next = 26;
              break;
            }

            return _context.abrupt("return", {
              type: SchedulingResultType.SAME_DAY_CONFLICT,
              message: getConstraintMessage(data)
            });

          case 26:
            if (!isWeeklyWarning(data)) {
              _context.next = 28;
              break;
            }

            return _context.abrupt("return", {
              type: SchedulingResultType.WEEKLY_WARNING,
              message: getWeeklyWarningMessage(data),
              apiFn: apiFn,
              payload: payload
            });

          case 28:
            if (!((_data2 = data) !== null && _data2 !== void 0 && _data2.success)) {
              _context.next = 30;
              break;
            }

            return _context.abrupt("return", {
              type: SchedulingResultType.SUCCESS,
              data: data
            });

          case 30:
            return _context.abrupt("return", {
              type: SchedulingResultType.ERROR,
              message: ((_data3 = data) === null || _data3 === void 0 ? void 0 : _data3.message) || 'Unable to complete scheduling. Please try again.'
            });

          case 31:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 9]]);
  }));

  return function executeSchedulingRequest(_x) {
    return _ref2.apply(this, arguments);
  };
}();

exports.executeSchedulingRequest = executeSchedulingRequest;